import NewPrice from './NewPrice';
import type { CalculatedPlan, CalculatedTierPoint, WorksheetInputEditor } from './PriceSimulationWorksheet.types';
import WorksheetAdjustmentCell from './WorksheetAdjustmentCell';
import WorksheetKeepPriceSlot from './WorksheetKeepPriceSlot';
import { formatTierRange, withSek } from './worksheetFormatters';

interface WorksheetBreakpointRowProps {
    productId: string;
    plan: CalculatedPlan;
    point: CalculatedTierPoint;
    position: number;
    isLocked: boolean;
    editor: WorksheetInputEditor;
}

const WorksheetBreakpointRow = ({ productId, plan, point, position, isLocked, editor }: WorksheetBreakpointRowProps) => (
    <tr className="worksheet-tier-breakpoint-row">
        <td>
            <div className="pl-64">
                <span className="body-sm text-secondary">{formatTierRange(plan.tierPoints ?? [], position)}</span>
            </div>
        </td>
        <td className="text-right">{withSek(point.currentUnitPrice)}</td>
        <td className="text-center">
            {/* Included (0 kr) breakpoints are kr-only: a percentage off a 0 baseline can never change the price. */}
            <WorksheetAdjustmentCell
                target={{ productId, planId: plan.id, breakpointIndex: point.index }}
                currentPrice={point.currentUnitPrice}
                newPrice={point.newUnitPrice}
                adjustment={point.adjustment}
                isKrOnly={point.isIncluded}
                isLocked={isLocked}
                editor={editor}
            />
        </td>
        <td className="text-right">
            <div className="d-flex justify-content-between align-items-center gap-8">
                <WorksheetKeepPriceSlot
                    isKept={point.isKept}
                    onToggle={isLocked ? undefined : () => editor.onToggleKept({ productId, planId: plan.id, breakpointIndex: point.index }, plan)}
                />
                <NewPrice price={point.newUnitPrice} delta={point.delta} />
            </div>
        </td>
    </tr>
);

export default WorksheetBreakpointRow;
